<script>
import options from "./BasketCard.options";
export default options;
</script>

<template>
  <article
    class="kb-basket-card"
    :class="{ 'kb-basket-card--miniBasket': miniBasket }"
  >
    <div class="kb-basket-card__content-wrapper">
      <div class="kb-basket-card__content-wrapper-left">
        <figure class="kb-basket-card__image kb-image-module">
          <div class="kb-image-module__image-container">
            <picture class="kb-image-module__image" v-if="data.imageUrl">
              <a :href="variantData.variant.url">
                <img
                  :src="data.imageUrl"
                  alt=""
                />
              </a>
            </picture>
          </div>
        </figure>

        <template v-if="!miniBasket">
          <p class="kb-basket-card__title">
            <a :href="variantData.variant.url">{{
              variantData.variant.displayName
            }}</a>
            <a :href="variantData.variant.url"
              ><span class="kb-basket-card__product-number">
                {{ data.productNumber }}</span
              ></a
            >
          </p>
        </template>
        <template v-if="miniBasket">
          <p class="kb-basket-card__title">
            <span class="kb-basket-card__product-amount">
              {{ `${variantData.variant.quantity} X` }}</span
            >
            {{ variantData.variant.displayName }}
          </p>
        </template>
      </div>

      <div
        class="kb-basket-card__content-wrapper-right"
        :class="{
          'kb-basket-card__content-wrapper-right--sold-out-show':
            displaySoldOutMessage,
        }"
      >
        <div class="kb-basket-card__controls-wrapper">
          <AmountSelector
            :sku="data.productNumber"
            :setAmount="setAmount"
            :startAmount="variantData.variant.quantity"
            :minAmount="variantData.minAmount"
            :maxAmount="variantData.maxAmount"
            :displayMessage="displayMessage"
            :doNotUseInputValidation="true"
            :readOnly="readOnlyAmount"
          />
          <button
            class="kb-basket-card__delete-button"
            @click="handleDeleteButton"
          >
            <span class="kb-visually-hidden">{{ getLabel("deleteItemInCart") ?? 'Slet vare' }}</span>
            <svg
              width="20"
              height="22"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              role="presentation"
            >
              <path
                d="M15.25 21.125h1.125l2.25-16.5H1.375l2.25 16.5h9l1.5-14.625M7 19.25 5.875 6.5M10 19.25V6.5M1 2.375h18M11.875 2.375 11.5.875H7.75l-.375 1.5"
                stroke="#3C3C3C"
              />
            </svg>
          </button>
        </div>

        <p class="kb-basket-card__price">
          {{ variantData.variant.price.displayPrice }}

          <template v-if="variantData.variant.price.displayBeforePrice">
            <span class="kb-basket-card__price-original">
              {{ variantData.variant.price.displayBeforePrice }}</span
            >
          </template>
        </p>
      </div>
    </div>

    <!-- in mini basket cards have no error-modes -->
    <template v-if="!miniBasket">
      <!-- Below are error scenario styles -->

      <!-- class for error-message styles from product details 
        as they are identical & so future changes can be done in one place -->

      <template v-if="!validationError.show">
        <!-- only show is no other error message active from BE -->
        <p
          class="kb-product-detail__error-message"
          :class="displayMaxAmountMessage"
        >
          {{ errorMaxAmountMessage }}
        </p>
        <p
          class="kb-product-detail__error-message"
          :class="displayMinAmountMessage"
        >
          {{ errorMinAmountMessage }}
        </p>
      </template>

      <p
        class="kb-product-detail__error-message"
        :class="{
          'kb-product-detail__error-message--show': validationError.show,
        }"
      >
        {{ validationError.message }}
      </p>

      <div
        class="kb-basket-card__error"
        :class="{
          'kb-basket-card__error--sold-out-show': displaySoldOutMessage,
        }"
      >
        <p>{{ getLabel("soldOut") }}</p>
      </div>

      <div
        class="kb-basket-card__error"
        :class="{
          'kb-basket-card__error--removed-from-basket':
            displayAlreadyRemovedFromBasket,
        }"
      >
        <p>{{ getLabel("itemHasBeenRemoved") }}</p>
        <button :id="`product-undo-delete-${variantData.variant.sku}`" class="kb-button" @click="displayAlreadyRemoved(false, data.productNumber)">
          <span class="kb-visually-hidden">{{ getLabel("itemHasBeenRemoved") }}</span>
          {{
            getLabel("cancel") 
          }}
        </button>
      </div>
    </template>
  </article>
</template>
